import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import React, { ReactNode } from 'react';
import { GeneralTranscription } from '../../../config/constants/transcription.constant';

type LoadingProps = {
  rotate: boolean | undefined;
  text?: string;
  wrapClass?: string;
  children?: ReactNode;
};

const Loading: React.FC<LoadingProps> = ({ rotate = true, text = GeneralTranscription.LOADING_TEXT, wrapClass, children }) => {
  return (
    <div className={`${wrapClass || ''}`}>
      <Spin spinning={rotate} tip={text} indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}>
        {children}
      </Spin>
    </div>
  );
};
export default Loading;
